import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import PropTypes from 'prop-types'; // Import PropTypes
import { createScene } from '../store/sm';
import Header from '../components/Header';
import { headerHeight, landingBackgroundColor } from '../config';

function Loading({ className }) {
  const {
    connected,
    loading,
    error,
    connectionState,
  } = useSelector(({ sm }) => sm);
  const dispatch = useDispatch();

  const {
    percentageLoaded, name, currentStep, totalSteps,
  } = connectionState;

  const stateNameMap = {
    SearchingForDigitalPerson: 'Searching For Digital Person',
    DownloadingAssets: 'Downloading Assets',
    ConnectingToDigitalPerson: 'Connecting To Digital Person',
  };

  const stateName = (name in stateNameMap) ? stateNameMap[name] : name;

  const history = useHistory(); // Hook to programmatically navigate

  const createSceneIfNotStarted = () => {
    if (!loading && !connected && !error) {
      dispatch(createScene());
    }
  };

  // Start the scene on component mount
  useEffect(() => {
    createSceneIfNotStarted();
  }, []);

  // Redirect to /video when loading is done and connected
  useEffect(() => {
    if (connected) {
      history.push('/aiperson2/video');
    }
  }, [connected, history]);

  const [page, setPage] = useState(0);
  const pages = [
    // your existing pages content here
  ];

  return (
    <div className={className}>
      <Header />
      <div className="container">
        <div className="row justify-content-center align-items-center">
          <div className="col-11 col-md-6 text-center mobile">
            <div className="row">
              {pages[page]}
            </div>
            <div className="row justify-content-center">
              <div>
                {page < pages.length - 1 && (
                  <button
                    className="btn btn-dark m-2"
                    type="button"
                    onClick={() => setPage(page + 1)}
                    style={{ backgroundColor: '#3C3C3C', border: '2px solid #3C3C3C' }}
                    aria-label={`Go to page ${page + 2}`} // Descriptive aria-label
                  >
                    Next
                  </button>
                )}
              </div>
            </div>
            {
              percentageLoaded < 100 && (
                <div>
                  <div className="progress mt-1">
                    <div
                      className="progress-bar"
                      role="progressbar"
                      style={{ width: `${percentageLoaded}%` }}
                      aria-valuenow={percentageLoaded}
                      aria-valuemin="0"
                      aria-valuemax="100"
                      aria-label={`Go to page ${page + 2}`}
                    />
                  </div>
                  {stateName && (
                    <pre>
                      {`${stateName} (${currentStep} out of ${totalSteps - 1} steps)`}
                    </pre>
                  )}
                </div>
              )
            }
          </div>
        </div>
      </div>
    </div>
  );
}

// Add PropTypes validation
Loading.propTypes = {
  className: PropTypes.string.isRequired, // Validate className prop
};

export default styled(Loading)`
  background: ${landingBackgroundColor};
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center bottom;

  width: 100vw;
  height: 100vh;
  color: #3C3C3C;

  &>.container>.row {
    height: calc(100vh - ${headerHeight});
  }

  .mobile {
    @media (max-width: 400px) {
      width: 100%;
      max-width: 300px;
    }
  }

  .connected-button {
    background-color: #3C3C3C;
    border: 2px solid #3C3C3C;
  }

  .unconnected-button {
    font-size: 14px;
    font-family: "Helvetica Neue";
  }

  .tutorial-icon {
    width: 180px;
    height: 180px;
    aspect-ratio: 1;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #EAEAEA;
  }

  .open-dot {
    border: 2px solid #3C3C3C;
    width: 8px;
    height: 8px;
    border-radius: 50%;
  }

  .closed-dot {
    border: 2px solid #3C3C3C;
    background: #3C3C3C;
    width: 8px;
    height: 8px;
    border-radius: 50%;
  }
`;
